import { muiTheme } from "@/styles/theme";
import { Box, Typography } from "@mui/material";
import ConfirmationModal from "@/modules/common/components/modals/cofirmation-modal";
import { toast } from "react-toastify";
import useDeleteLead from "@/modules/lead-page/hooks/lead-info/lead-actions/delete-lead.hook";
import { useEffect, useState } from "react";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const DeleteLead = () => {
  const { handleDeleteLeadLead, isLoadingDeleteLead, isError, isSuccess } =
    useDeleteLead();
  const [confirmationModal, setConfitmationModal] = useState(false);

  useEffect(() => {
    if (isError) {
      toast.error("Something went wrong", {
        position: "bottom-left",
        autoClose: 3000,
      });
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      window.location.href = "/leads";
      setConfitmationModal(false);
    }
  }, [isSuccess]);
  return (
    <>
      <ConfirmationModal
        open={confirmationModal}
        setOpen={setConfitmationModal}
        onConfirmHandler={handleDeleteLeadLead}
        title={"Delete Lead"}
        body={"Are you sure you want to delete this lead?"}
        isLoading={isLoadingDeleteLead}
      />
      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          ":hover": {
            backgroundColor:
              muiTheme.colorSchemes.light.palette.main.actionDisabled,
          },
        }}
        onClick={() => setConfitmationModal(true)}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.extension.negative,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
          variant="h5_bold"
        >
          Delete Lead
        </Typography>
      </Box>
    </>
  );
};

export default DeleteLead;
